import { AddOnPolicyAssignment } from '../../types/bulkUpdate'

export type PolicyChoice = { label: string; value: string } | null

// The picker's "remove" option. A real set id is a 24-hex ObjectId, so this cannot collide.
export const REMOVE_ADD_ON_POLICY = 'remove-add-on-policy'

// Untouched codes are omitted (their sets stay as they are); "remove" sends null, which clears
// the code's set over the update's periods. An empty id is never sent: the BFF would read it
// as a removal.
export const toAddOnPolicyAssignments = (
  choices: Record<string, PolicyChoice>
): AddOnPolicyAssignment[] | undefined => {
  const assignments = Object.entries(choices).flatMap(([addOnCode, choice]) =>
    choice?.value
      ? [
          {
            addOnCode,
            policySetID:
              choice.value === REMOVE_ADD_ON_POLICY ? null : choice.value
          }
        ]
      : []
  )
  return assignments.length > 0 ? assignments : undefined
}

// The codes whose sets the update will clear, for the warning shown before it is sent.
export const removedAddOnCodes = (
  choices: Record<string, PolicyChoice>
): string[] =>
  Object.entries(choices)
    .filter(([, choice]) => choice?.value === REMOVE_ADD_ON_POLICY)
    .map(([addOnCode]) => addOnCode)

interface BulkAddOnPoliciesInput {
  isChannelSelected: string
  isRoleAccommodation: boolean
  choices: Record<string, PolicyChoice>
}

// Add-on policy sets are CRS terms, and accommodation roles cannot assign them; for anyone else
// the field is left out so a channel update never touches them.
export const bulkAddOnPolicies = ({
  isChannelSelected,
  isRoleAccommodation,
  choices
}: BulkAddOnPoliciesInput): AddOnPolicyAssignment[] | undefined =>
  isChannelSelected === 'CRS' && !isRoleAccommodation
    ? toAddOnPolicyAssignments(choices)
    : undefined
